// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4a5fb76c","977":"e66b4161"}[chunkId] + ".chunk.js";
};